import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/admin/admin.service';
import { FreshAuthService } from '../fresh-auth.services';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { debounceTime, distinctUntilChanged, flatMap } from 'rxjs/operators';

@Component({
  selector: 'wl-error-log',
  templateUrl: './error-log.component.html',
  styles: [],
  providers: [DatePipe]
})
export class ErrorLogComponent implements OnInit {
  maxDate: any;
  subheading1: any;
  loading: boolean;
  totalCount: any;
  totalPage: number = 1;
  limit: number = 10;
  offset: number = 1;
  allUsers: any;
  subheading2: string;
  startDate: any;
  todayDate: any;
  startDateNew: Date;
  endDateNew: Date;
  dropdownSelection: string;
  dropdownOptions: object[] = [
    { type: "ALL", value: "" },
    { type: "EMERGENCY", value: "EMERGENCY" },
    { type: "ALERT", value: "ALERT" },
    { type: "CRITICAL", value: "CRITICAL" },
    { type: "ERROR", value: "ERROR" },
    { type: "WARNING", value: "WARNING" },
    { type: "NOTICE", value: "NOTICE" },
    { type: "INFO", value: "INFO" },
    { type: "DEBUG", value: "DEBUG" }
  ];
  pageId = 1;
  search = new UntypedFormControl();
  noUserFound: string;
  page: number = 1;
  searchHolder: string;
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateInMs: number;
  endDateInMs: number;
  roleId: any;
  startDateConvert: any;
  endDateConvert: any;
  showTable = true;



  constructor(private adminservice: AdminService, private freshAuthService: FreshAuthService,
    private datePipe: DatePipe, private snackbar: MatSnackBar, private customer: FreshAuthService,) {

      this.search.valueChanges.pipe(
        debounceTime(600),
        distinctUntilChanged(),
        flatMap((search) => this.customer.getErrorLogFilter(
          search,
          1,
          1,
          10,
          this.dropdownSelection,
          this.startDateNew.toString().split('-').reverse().join('-'),
          this.endDateNew.toString().split('-').reverse().join('-')
        ))
      ).subscribe(
        (res) => {
          this.showTable = true;
          if (res) {
            this.loading = false;
            console.log("resp for search " + JSON.stringify(res));
            if (res && res.results && res.results.length == 0) {
              this.noUserFound = 'Data not found';
              this.showTable = false;
            } else {
              this.noUserFound = null;
            }
            this.allUsers = [];
            this.page = 1;
            this.allUsers = res.results ? res.results : [];
            console.log(this.allUsers, 'allusers');
            this.totalCount = res && res.count ? res.count : 0;
            this.totalPage = Math.ceil(this.totalCount / 10);
            console.log("this.totalPage " + this.totalPage);
          } else {
            this.loading = false;
            this.noUserFound = 'Data not found';
            this.showTable = false;
          }
        },
        (err) => {
          this.loading = false;
          throw err;
        }
      );
    this.searchHolder = "Search";
  }

  ngOnInit() {

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading1 = this.adminservice.getSolID();
    this.getData(1, 10);
  }

  onSearchClick(event) {
    this.loading = true;
  }

  // onSubmit() {
  //   // Handle the form submission here
  //   console.log('Start Date:', this.startDateNew);
  //   console.log('End Date:', this.endDateNew);
  //   console.log('Dropdown Selection:', this.dropdownSelection);
  //   this.pageId = 1;
  //   this.page = 1;
  //   this.offset = 1;
  //   this.selectedStartDate = this.startDateNew;
  //   this.selectedEndDate = this.endDateNew;
  //   console.log(this.startDateNew, this.endDateNew)
  //   let date = new Date(this.selectedStartDate);
  //   this.dateInMs = date.getTime();
  //   let strStart = this.dateInMs.toString();
  //   sessionStorage.setItem('filterDateErrorLogStart', strStart)
  //   let storeEnddate = new Date(this.selectedEndDate);
  //   this.endDateInMs = storeEnddate.getTime();
  //   let strEnd = this.endDateInMs.toString();
  //   sessionStorage.setItem('filterDateErrorLogEnd', strEnd)
  //   console.log('check date', this.endDateInMs);
  //   if (this.dateInMs <= this.endDateInMs) {
  //     let dateType = "dateRange"
  //     // this.showSelectedDate = true;     
  //     // let startDateConvert = this.startDateNew.split('-').reverse().join('-');
  //     // let endDateConvert = this.endDateNew.split('-').reverse().join('-');
  //     //   this.selectedDate =  startDateConvert+ ' - ' + endDateConvert;  
  //     this.customer.getErrorLogFilterDate("", this.roleId, 0, 10, this.dateInMs, this.endDateInMs, dateType, this.dropdownSelection).subscribe(res => {
  //       console.log(res);
  //       if (res && res.results) {
  //         if (res && res.results) {
  //           this.allUsers = res.results ? res.results : "";
  //           this.totalCount = res && res && res.count ? res.count : 0;
  //           this.totalPage = Math.ceil(this.totalCount / 10);
  //         }
  //       } else {
  //         // this.allUsers = this.getEmptyArray()
  //         // this.closeButtonClick()
  //         this.snackbar.open("No Applicants found. The Filter is not Applied", 'OK', { duration: 4000 })
  //       }
  //     })
  //   } else {
  //     this.snackbar.open("Please enter the valid date", 'OK', { duration: 4000 })
  //   }
  // }

  onSubmit() {
    this.pageId = 1;
    this.page = 1;
    this.offset = 1;
    this.customer.getErrorLogFilter(this.search.value, 1, 1, 10, this.dropdownSelection,
      this.startDateNew.toString().split('-').reverse().join('-'), this.endDateNew.toString().split('-').reverse().join('-')).subscribe(res => {
        this.showTable = true;
        if (res) {
          this.loading = false;
          console.log("resp for searc " + JSON.stringify(res));
          if (res && res.results && res.results.length == 0) {
            this.noUserFound = 'Data not found ';
            this.showTable = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.noUserFound = null;
          }
          this.allUsers = [];
          this.page = 1;

          this.allUsers = res.results ? res.results : [];
          console.log(this.allUsers, 'allusers');
          this.totalCount = res && res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log("this.totalPage " + this.totalPage);

        } else if (!res) {
          this.loading = false;
          this.noUserFound = 'Data not found ';
          this.showTable = false;
        } else if (res && res.success == false) {
          this.loading = false;
          console.log('this.allUsers')
          this.allUsers = res.results ? res.results : [];

        }

      }, err => {
        this.loading = false;
        throw err
      });
  }

  downloadFile() {
    this.loading = true;
    this.freshAuthService.downloadErrorFile(this.search.value,this.startDateNew.toString().split('-').reverse().join('-'), this.endDateNew.toString().split('-').reverse().join('-'),this.dropdownSelection).subscribe((resp) => {
      if (resp && resp.filePath) {
        console.log(resp.filePath)
        /* FileSaver.saveAs(resp.filePath, `filename.csv`) */
        this.base64ToBlob(resp.filePath)
        FileSaver.saveAs(this.base64ToBlob(resp.filePath), "Error-Log"+'_'+this.startDateNew.toString().split('-').reverse().join('-')+ "_" +  this.endDateNew.toString().split('-').reverse().join('-'));
        this.loading = false;
      }
    })
  }

  base64ToBlob(b64Data, sliceSize = 512) {
    let byteCharacters = atob(b64Data); //data.file there
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }


  getData(offset, limit) {
    this.loading = true;
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');
    let searchQuery = '';
    let level = this.dropdownSelection;
    let currentPage = '1';
    let recordsPerPage = '10';

    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = this.datePipe.transform(startOfMonth, 'yyyy-MM-dd');
    this.startDateNew = this.startDate;
    this.todayDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    this.endDateNew = this.todayDate;
    this.startDateConvert = this.startDate.split('-').reverse().join('-');
    this.endDateConvert = this.todayDate.split('-').reverse().join('-');
    // let startDateConvert = '28-06-2021'
    // let endDateConvert = '28-07-2023'
    console.log(this.startDate, this.todayDate)
    //this.freshAuthService.get_error_log(searchQuery,startDateConvert,endDateConvert,'dateRange',level,pageSize,continuationKey ).subscribe(res => {
    this.freshAuthService.get_error_log(offset, limit, searchQuery, this.startDateConvert, this.endDateConvert, level).subscribe(res => {
      console.log(res, "hello");
      console.log(res, "hello");
      if (res && res.results) {
        this.loading = false;
        this.totalCount = res && res.count ? res.count : 0;

        this.totalPage = Math.ceil(this.totalCount / 10);

        this.allUsers = res.results ? res.results : [];
        //  this.allUsers = sample.results;
        console.log('alluser', this.allUsers);
      }
      else {
        this.loading = false;
        this.snackbar.open("Reports not found", 'OK', { duration: 4000 })
      }
    }, err => {
      this.loading = false;
      throw err
    });
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    console.log(pageId)
    this.pageId = pageId;
    this.loading = true;

    console.log("before page " + this.page + "offset " + this.offset + "limit " + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log("after page " + this.page + "offset " + this.offset + "limit " + this.limit);

    console.log(this.search)
    this.customer.getErrorUsers(this.search.value, roleId, offset, limit, this.startDateNew.toString().split('-').reverse().join('-'), this.endDateNew.toString().split('-').reverse().join('-'), this.dropdownSelection).subscribe(res => {
      console.log('inside next')
      this.loading = false;
      console.log("result " + JSON.stringify(res));
      this.allUsers = res && res.results ? res.results : [];
      // this.getFailureReason();
      this.totalCount = res && res && res.count ? res.count : 0;

      this.totalPage = Math.ceil(this.totalCount / 10);
      console.log("this.totalPage " + this.totalPage);
      // this.custId = res.result.custId;
      // console.log("custId " +  res.result.custId);
    }, err => {
      this.loading = false;
      this.allUsers = Observable[''];
      throw err
    })

  }


}
